import { useEffect } from 'react';
var childNeedsVisibilityEvent = 'child-needs-visibility';
export var useChildNeedsVisibilityListener = function useChildNeedsVisibilityListener(domElementRef, handler) {
  useEffect(function () {
    var _domElementRef$curren;

    if (!(domElementRef !== null && domElementRef !== void 0 && (_domElementRef$curren = domElementRef.current) !== null && _domElementRef$curren !== void 0 && _domElementRef$curren.addEventListener)) return;
    var current = domElementRef === null || domElementRef === void 0 ? void 0 : domElementRef.current;
    var evHandler = handler;
    current === null || current === void 0 ? void 0 : current.addEventListener(childNeedsVisibilityEvent, evHandler);
    return function () {
      current === null || current === void 0 ? void 0 : current.removeEventListener(childNeedsVisibilityEvent, evHandler);
    };
  }, [domElementRef, handler]);
};
export var sendChildNeedsVisibilityRequest = function sendChildNeedsVisibilityRequest(elementSelector) {
  if (!document) return;
  var htmlElement = typeof elementSelector === 'string' ? document.querySelector(elementSelector) : elementSelector;
  htmlElement === null || htmlElement === void 0 ? void 0 : htmlElement.dispatchEvent(new Event(childNeedsVisibilityEvent, {
    bubbles: true
  }));
};